import { createSelector } from 'reselect';
import { bottomNavOffersSelector } from 'selectors/testTarget/offers/bottomNavOffers/bottomNavOffersSelector';

const experienceSelector = createSelector(bottomNavOffersSelector, bottomNavOffers => bottomNavOffers.experience);

export { experienceSelector };
